import { History } from "@mui/icons-material";
import { useSessionContext } from "../../contexts/SessionContext";
import { IFeatures } from "../../utils/interfaces";
import { AccessHistory } from "./AccessHistory";
import { currentFeatures } from "../../configs/Settings";
import AccessLogs from "@/fluxvet/pages/access/AccessLogs";

export function useAccessHistory() {
  const { access } = useSessionContext();

  const configs: IFeatures = {
    active: access?.type === "patient" && !currentFeatures.register,
    path: "/history",
    icon: History,
    text: "Histórico de acessos",

    sideMenu: true,
    sideMenuIndex: 3,

    avatarMenu: true,
    avatarIndex: 2,

    component: () =>
      currentFeatures.defaultApp ? <AccessHistory /> : <AccessLogs />,
  };

  return configs;
}
